<template>
  <div class="c-lo-dialog">
    <div class="c-content">
      <div class="content__left">
        <card-header>知识点详情</card-header>
        <point-list :data="data" v-model="knowledgeCode" />
      </div>
      <div class="content__right">
        <p class="content__header" style="padding-bottom:24px;">
          <span class="content__title">{{videoHandout.knowledge_name}}</span>
          <i class="el-icon-close" style="z-index:2" @click="$emit('update:visible', false)"></i>
        </p>
        <div style="height:calc(100% - 49px);overflow:auto;position: relative;">
          <div ref="header" class="s-header"></div>
          <el-tabs
            v-model="activeName"
            class="i-tab--sm"
          >
            <el-tab-pane
              :label="item.label"
              :name="item.name"
              v-for="item in tabList"
              :key="item.name">
                <component :is="item.component" :data="getData(item.name)" />
              </el-tab-pane>
          </el-tabs>
          <footer style="padding-top:20px">
            <button
              :style="hasPre?'visibility:visible':'visibility:hidden'"
              @click="onPreClick"
            >上一个知识点</button>
            <button
              :style="hasNext?'visibility:visible':'visibility:hidden'"
              @click="onNextClick"
            >下一个知识点</button>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardHeader from '@/components/card-header.vue';
import { getVideoAndHandoutByCode, getQuestionListByKnowledgeCode } from '@/api/pt';
import PointList from './point-list.vue';
import VideoHandout from './video-handout.vue';
import QuestionResource from './question-resource.vue';
import { getSign } from '@/utils';

export default {
  components: { CardHeader, PointList },
  name: 'LoDialog',
  props: {
    code: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    subjectId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      activeName: 'handout',
      knowledgeCode: this.code,
      videoHandout: {},
      questionList: [],
    };
  },
  computed: {
    currentIndex() {
      return this.data
        .findIndex((item) => item.knowledge_code === this.knowledgeCode);
    },
    hasPre() {
      return this.currentIndex > 0;
    },
    hasNext() {
      return this.currentIndex < this.data.length - 1;
    },
    hasHandout() {
      return this.videoHandout;
    },
    hasQuestion() {
      return this.questionList.length;
    },
    tabList() {
      return [{
        label: '视频讲义',
        name: 'handout',
        component: VideoHandout,
        visible: this.hasHandout,
      }, {
        label: '题目资源',
        name: 'question',
        component: QuestionResource,
        visible: this.hasQuestion,
      }].filter((item) => item.visible);
    },
  },
  watch: {
    knowledgeCode: {
      immediate: true,
      handler(v) {
        const param = {
          knowledge_code: v,
          subject_id: this.subjectId,
        };
        param.sign = getSign(param);
        const code = {
          knowledge_code: v,
        };
        code.sign = getSign(code);
        Promise.all([getVideoAndHandoutByCode(code).then((res) => {
          if (res.code === 200) {
            this.videoHandout = res.data;
          }
        }),
        getQuestionListByKnowledgeCode(param).then((res) => {
          if (res.code === 200) {
            this.questionList = res.data;
          }
        })]).then(() => {
          setTimeout(() => {
            this.$refs.header.scrollIntoView({
              behavior: 'smooth',
            });
          }, 20);
        });
      },
    },
  },
  methods: {
    onPreClick() {
      this.knowledgeCode = this.data[this.currentIndex - 1].knowledge_code;
    },
    onNextClick() {
      this.knowledgeCode = this.data[this.currentIndex + 1].knowledge_code;
    },
    getData(name) {
      const dataMap = {
        question: this.questionList,
        handout: this.videoHandout,
      };
      return dataMap[name];
    },
  },
};
</script>

<style lang="scss" scoped>
.c-lo-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.6);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .s-header {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 1px;
    visibility: hidden;
  }
  .c-content {
    width: 960px;
    height: 570px;
    background: #FFFFFF;
    border-radius: 4px;
    position: relative;
    display: flex;
    max-width: 90%;
    max-height: 90%;
  }
  .el-icon-close {
    position: absolute;
    top: 17px;
    right: 17px;
    color: rgba(126, 129, 133, 1);
    font-size: 30px;
  }
  .content__left {
    width: 220px;
    height: 100%;
    background: #FFFFFF;
    box-shadow: 2px 0px 8px 0px rgba(220, 225, 236, 0.5);
    border-radius: 4px 0px 0px 4px;
    padding: 24px;
    box-sizing: border-box;
  }
  .content__right {
    flex: 1;
    box-sizing: border-box;
    padding: 28px 23px;
    overflow: hidden;
    position: relative;
    footer {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      margin-top: 20px;
    }
    button { color: rgba(25, 137, 250, 1); font-size: 14px;}
  }
  .content__title {
    width: 181px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 25px;
    position: relative;
    &::after {
      content: '';
      width: 100%;
      height: 13px;
      background: rgba(230, 162, 60, 0.2);
      border-radius: 7px;
      position: absolute;
      left: 0;
      bottom: 5px;
    }
  }
  .content__header {
    padding-left: 33px;
    background-image: url('~@/views/pt/images/ic_star.png');
    background-repeat: no-repeat;
    background-position: left top 5px;
    background-size: 24px auto;
    padding-left: 32px;
  }
}
</style>
